<template>
	<transition name="el-zoom-in-center">
		<div id="livePlay" v-show="livePlayShow">
			<!-- 是否密码房直播 -->
			<div class="not_living" v-if="isPasswordLive == true">
				<div class="freeLive">
					<img src="../../assets/img/live/no_play.png" alt="">
				</div>
				<div class="freeLiveDesc">
					<div class="passwordLive-title">
						该直播为密码房直播,请<span style="color: #00e7ffeb;cursor: pointer;" @click="passwordLive()">输入密码</span>后观看
					</div>
				</div>
			</div>
			<!-- 是否免费直播未开播 -->
			<div class="not_living" v-if="liveDetail.lvrIsFree == 0 && (liveDetail.lvrStatus == 0 || liveDetail.lvrStatus == 2) && isPasswordLive == false">
				<div class="freeLive">
					<img src="../../assets/img/live/no_play.png" alt="">
				</div>
				<div class="freeLiveDesc">
					<div class="not_living-title">
						该直播暂未开始
					</div>
				</div>
			</div>
			<!-- 是否付费直播未开播 -->
			<div class="not_living" v-if="liveDetail.lvrIsFree == 1 && (liveDetail.lvrStatus == 0 || liveDetail.lvrStatus == 2 || (liveDetail.lvrStatus == 1 && liveDetail.isBuy == 0 && livePreviewEndShow == true)) && isPasswordLive == false">
				<div class="payLive">
					<img src="../../assets/img/live/no_play.png" alt="">
				</div>
				<!-- 未购买提示 -->
				<div class="payLiveDesc" v-if="liveDetail.isBuy == 0">
					<div class="not_living-title">
						该直播为付费直播
					</div>
					<div class="not_living-desc" v-if="liveDetail.lvrIsFree == 1 && (liveDetail.lvrStatus == 0 || liveDetail.lvrStatus == 2) && livePreviewEndShow == false">
						直播还未开始，购买后提醒您观看
					</div>
					<div class="not_living-desc" v-if="liveDetail.lvrIsFree == 1 && liveDetail.lvrStatus == 1 && liveDetail.seeDuration <= 0 && livePreviewEndShow == true">
						试看已结束，请购买后继续观看
					</div>
					<div class="not_living-pay" @click="liveBuyCard()">立即购买</div>
				</div>
				<!-- 已购买提示 -->
				<div class="payLiveDesc" v-else>
					<div class="not_living-title">
						已有当前直播观看权限
					</div>
					<div class="not_living-desc">
						直播还未开始，请您耐心等待
					</div>
					<!-- <div class="not_living-pay" @click="liveBuyCard()">续费购买</div> -->
				</div>
			</div>

			<div class="prism-player" id="J_prismPlayer" v-if="liveDetail.lvrStatus == 1"></div>
			<script type="text/template" id="endPreviewTemplate">
			  <div class="vip_limit_content">
			    <div class="vip_limit_wrap">
			      <p class="title">Purchase Full Version</p>
			      <div class="vip_limit_button_box">
			        <a class="vip_limit_btn" @click="liveBuyCard()">Become VIP</a>
			      </div>
			      <div class="vip_limit_close"><span class="vip_limit_close_btn">x</span></div>
			    </div>
			  </div>
			</script>


			<!-- 买卡支付页 -->
			<el-dialog
			:visible.sync="buyCardShow"
			:close-on-click-modal="false"
			width="70%">
				<v-buyCard :liveDetailData="liveDetail" ref="buyCard"></v-buyCard>
			</el-dialog>
			<!-- 抽奖提示页 -->
			<el-dialog class="luckDialog"
			:visible.sync="luckNotice.showStatus"
			:modal="false"
			:show-close="false"
			:close-on-click-modal="false"
			:fullscreen="true"
			:center="true"
			width="100%">
				<div id="luckNotice">
					<div class="luck-desc">{{luckNotice.luckDesc}}</div>
					<img src="../../assets/img/live/中奖啦.png" alt="" v-if="luckNotice.luckStatus == true">
					<img src="../../assets/img/live/没中奖.png" alt="" v-if="luckNotice.luckStatus == false">
				</div>
				<div class="luckDialog-close" @click="luckNotice.showStatus = false">
					<img src="../../assets/img/live/取消.png">
				</div>
			</el-dialog>
		</div>
	</transition>
</template>

<script>
	import vBuyCard from '../common/buy_card'
	import commonJs from '../../../static/js/common.js'
	export default{
		name:'livePlay',
		data(){
			return {
				nowRoomId:0,
				liveDetail:{},
				freeLiveCoverShow:false,
				payLiveCoverShow:false,
				buyCardShow:false,
				livePlayShow:true,
				livePlayTime:0,
				aliPlayer:'',
				aliPlayerOptions:{
					width:'100%',
					height:'560px',
					isLive: true,
				},
				mqttClient:{},
				videoCanPlay:false,
				tryLookTimeNow:0,
				alreadyLookTime:0,
				liveComments:[],
				commentNum:0,
				livePreviewEndShow:false,
				isFullScreen:0,
				isPasswordLive:false,
				updateOnlineTimer:'',
				luckNotice:{
					luckStatus:false,
					showStatus:false,
					luckDesc:'好可惜，差点就中了',
				},
			};
		},
		props:{
			playerOptions:{
				type:Object,
				default:() => ({
					width:'100%',
					height:'560px',
					isLive:true
				})
			}
		},
		components:{
			'v-buyCard':vBuyCard,
		},
		created() {
			window.vm = this;

			// 监听事件
			window.addEventListener('resize', this.onresize);
		},
		mounted() {

		},
		beforeDestroy() {
		    // 取消监听事件
		    window.removeEventListener('resize', this.onresize);
		},
		watch:{
			nowRoomId:"nowRoomIdChange",
		},
		methods:{
			getMqttConnect(){
				var that = this;
				//+----------------构建mqtt配置参数------------------
				let mqttOptions = this.store.state.mqttOption;
				mqttOptions.clientId = 'pc_' + (new Date()).getTime() + Math.random().toString(16).substr(2, 5);
				//+----------------连接并接收数据--------------------
				this.mqttClient = this.mqtt.connect(mqttOptions.host, mqttOptions)
				// console.log('mqtt连接对象',this.mqttClient);
				this.mqttClient.on('reconnect', (error) => {
					// console.log('正在重连:', error)
				});

				this.mqttClient.on('error', (error) => {
					// console.log('连接失败:', error)
				});
				let title='live/'+ this.nowRoomId+'/comm'
				this.mqttClient.on('connect', (e) => {
					// console.log('成功连接服务器');

					//订阅一个主题
					this.mqttClient.subscribe(title, {
						qos: 0
					}, function (err) {
						if (!err) {
							// console.log("订阅成功")
						}
					});
					this.mqttClient.on('message', function (topic, message) {
						let masg = message.toString()
						// console.log('received msg:' , masg);
						var json = JSON.parse(masg);

						//直播状态通知
						if(json.type == 1){
							if(json.data.pull_url == ''){
								//+---------------------直播中断、结束------------------------
								if(json.data.liveStatus == 2 || json.data.liveStatus == 0){
									that.liveDetail.lvpPullUrlFlv = null;
									that.liveDetail.lvrStatus = 0;
									//试看结束图层显示
									that.livePreviewEndShow = false;
									that.aliPlayer.dispose();
								}
							}else{
								//+---------------------直播开始、重启--------------------------
								if(json.data.liveStatus == 1){
									//更新直播数据
									that.liveDetail.lvpPullUrlFlv = json.data.pull_url;
									that.liveDetail.lvrStatus = 1;
									if(that.aliPlayer) that.aliPlayer.dispose();
									setTimeout(() => that.aliPlayerInit(),1000);
									//that.aliPlayer.loadByUrl(json.data.pull_url);
									//window.location.reload(); //刷新一下
								}
							}
						}

						//直播人数变化
						if(json.type == 4){
							//+-----------------------更新直播间人气值-----------------------
							that.liveDetail.hotNum = json.data.popular_num;
						}

						//+------------------------------手动结束试看--------------------------
						if(json.type == 10 && json.data.lvrId == that.nowRoomId && json.data.status == 1){
							if(that.liveDetail.isBuy == 0){
								that.liveDetail.lvpPullUrlFlv = null;
								that.liveDetail.lvrIsFree = 1;
								that.liveDetail.lvrStatus = 1;
								that.liveDetail.seeDuration = 0;
								//试看结束图层显示
								that.livePreviewEndShow = true;
								that.aliPlayer.dispose();
							}
						}

						//+-----------------------------直播弹幕评论--------------------------
						if(json.type == 3){
							let commentItem = {
								id:json.data.ub_id,
								comment:commonJs.stringTrim(json.data.info),
								commentType:json.data.info_type,
								time:'刚刚',
								// time: commonJs.liveCommentTimeHandle(json.data.sendTime),
								user:{
									name:{
										text:json.data.sender,
										color:'#C60B09',
									},
									tag : {
									    bgColor:"#C60B09",
									    text :(json.data.identityName ? json.data.identityName : '用户')
									},
									avatar:json.data.small_img,
								},
							}

							//弹幕去重
							var isExist = commonJs.arrUnique(that.liveComments,commentItem);
							if(!isExist){
								that.liveComments.push(commentItem);
								that.commentNum = ++that.commentNum;
								if(that.commentNum >= 12){
									that.liveComments.shift();
								}
							}
						}

						//+-------------------------------中奖信息通知-----------------------------
						if(json.type == 11 && json.data.userIds !='' && json.data.lvrId == that.nowRoomId){
							//当前用户id
							var userInfo = JSON.parse(window.localStorage.getItem('user'));
							var userId = (userInfo.ubId).toString();
							//切割中奖者id
							var luckerIds = json.data.userIds.split(',');

							if(luckerIds.indexOf(userId) != -1){
								//中奖了
								that.luckNotice.showStatus = true;
								that.luckNotice.luckDesc = json.data.message;
								that.luckNotice.luckStatus = true;
							}else{
								//未中奖
								that.luckNotice.showStatus = true;
								that.luckNotice.luckStatus = false;
							}
						}
					});
				});
			},
			//直播切换
			nowRoomIdChange(){
				//+------------------未登录用户提示登录后观看----------------------
				if(!localStorage.getItem('user')){
					this.$alert('请您登录后观看', '您未登录', {
						confirmButtonText: '确定',
						callback: action => {
							this.$parent.$refs.header.login();
						}
					});
					return false;
				}

				//+-----------------数据处理------------------
				this.someDataHandle();
				//+-----------------切换效果------------------
				this.changeTransition();
				//+-----------------获取mqtt连接--------------
				this.getMqttConnect();
				//+-------------切换当前直播ID详情-------------
				this.getLiveDetail();
			},
			//数据处理
			someDataHandle(){
				//+---------------------清除定时----------------------------------
				this.clearTimer();
				//+-----------------切换直播,销毁已创建的播放器--------------------
				if(this.aliPlayer){
					this.aliPlayer.dispose();
				}
			},
			//直播切换过渡
			changeTransition(){
				this.livePlayShow = false;
				setTimeout(() => {
					this.livePlayShow = true;
				},200);
			},
			//获取直播详情
			getLiveDetail(){
				//+---------------------构建请求参数------------------------------
				let data = {
					lvrId: this.nowRoomId,
				};
				//+---------------------获取直播详情数据--------------------------
				this.apiServer.live.getDetail(this.qs.stringify(data))
				.then(res => {
					//+---------------------有异常情况------------------------
					if(res.data.code == 200 && (res.data.data.businessCode == 20 || res.data.data.businessCode == 30)){
						this.$message.error(res.data.data.businessMessage);
						return false;
					}

					//+--------------------详情数据获取成功-----------------------
					if(res.data.code == 200){
						if(res.data.data.businessCode == 10){
							//直播详情数据
							this.liveDetail = res.data.data;
							//向父级传递数据
							this.$emit("liveDetailChange",this.liveDetail);

							// this.liveJson.room.lvrRoomId = this.liveDetail.lvrRoomId;
							// this.liveJson.room.lvpPullUrl = this.liveDetail.lvpPullUrl;
							// this.liveJson.room.lvpPullUrlFlv = this.liveDetail.lvpPullUrlFlv;
							// this.liveJson.room.lvpPullUrlRtmp = this.liveDetail.lvpPullUrlRtmp;

							//选中的播放地址
							// this.liveDetail.lvpPullUrlFlv = this.liveDetail.lvpPullUrl;

							//+---------------------开播中------------------------
							if(this.liveDetail.lvrStatus == 1){
								//+------------------------------------------------------------------
								// Start 获取mqtt连接
								//+------------------------------------------------------------------
								// this.getMqttConnect();

								//+------------------------------------------------------------------
								// Start 直播地址协议与网页协议是否一致
								//+------------------------------------------------------------------
								this.checkVideoUrl();
							}

							//+---------------------心跳监控开关-------------------
							if(this.liveDetail.openHeartbeat == true){
								this.updateLiveOnline();
								this.updateOnlineTimer = setInterval(() => {
									this.updateLiveOnline();
								},60000);
							}else{
								this.clearTimer();
							}

							//按直播类型
							if(this.liveDetail.lvrIsFree == 0){
								//免费直播
								this.freeLiveHandle();
							}else{
								//付费直播
								this.payLiveHandle();
							}
						}else{
							this.$message.error(res.data.data.businessMessage);
						}
					}
				})
				.catch(error => {
					console.log(error)
				});
			},
			//免费直播处理
			freeLiveHandle(){
				//+-----------判断是否开播--------------
				//未开播状态【展示封面层】
				if(this.liveDetail.lvrStatus != 1){
					this.freeLiveCoverShow = true;
					if(this.aliPlayer){
						this.aliPlayer.dispose();
					}
					return false;
				}
				//开播中状态【初始化播放器】
				if(this.liveDetail.lvrStatus == 1){
					this.aliPlayerInit();
				}
			},
			//付费直播处理
			payLiveHandle(){
				//0 未开播状态【展示封面层】
				if(this.liveDetail.lvrStatus == 0){
					this.payLiveCoverShow = true;
					this.liveDetail.lvpPullUrlFlv = null;
					this.liveDetail.lvrIsFree = 1;
					this.liveDetail.lvrStatus = 0;
					//试看结束图层显示
					this.livePreviewEndShow = false;
					if(this.aliPlayer){
						this.aliPlayer.dispose();
					}
					return false;
				}
				//1 直播中状态
				if(this.liveDetail.lvrStatus == 1){
					//未购买【是否可以试看】
					if(this.liveDetail.isBuy == 0){
						//手动
						if(this.liveDetail.auditionChangeMode == 'MANUAL'){
							//手动结束试看结束
							if(this.liveDetail.auditionEndFlag == true){
								//试看结束，销毁播放器，弹出购买框
								this.liveDetail.lvpPullUrlFlv = null;
								this.liveDetail.lvrIsFree = 1;
								this.liveDetail.lvrStatus = 1;
								this.liveDetail.seeDuration = 0;
								//试看结束图层显示
								this.livePreviewEndShow = true;
								this.aliPlayer.dispose();
							}else{
								//初始化播放器
								this.aliPlayerInit();
							}
						}

						//自动
						if(this.liveDetail.auditionChangeMode == 'AUTO' || this.liveDetail.auditionChangeMode == ''){
							if(this.liveDetail.auditionFlag == false){
								//不需要试看【展示付费封面层】
								this.payLiveCoverShow = true;
								this.liveDetail.lvpPullUrlFlv = null;
								this.liveDetail.lvrIsFree = 1;
								this.liveDetail.lvrStatus = 1;
								this.livePreviewEndShow = true;
								this.aliPlayer.dispose();
								return false;
							}else{
								//获取试看时间
								this.tryLookTimeNow = this.liveDetail.seeDuration;

								//+---------------试看已经结束---------------------
								if(this.liveDetail.seeDuration <= 0){
									//试看结束，销毁播放器，弹出购买框
									this.liveDetail.lvpPullUrlFlv = null;
									this.liveDetail.lvrIsFree = 1;
									this.liveDetail.lvrStatus = 1;
									//试看结束图层显示
									this.livePreviewEndShow = true;
									this.aliPlayer.dispose();
									return false;
								}

								//需要试看【是否手动结束试看】
								this.aliPlayerInit();
							}
						}
					}else{
						//已购买【付费封面层隐藏|初始化播放器】
						this.payLiveCoverShow = false;
						this.aliPlayerInit();
					}
				}
				//2 更换设备
				if(this.liveDetail.lvrStatus == 2){
					this.$message('更换设备中，请稍后重试');
					return false;
				}
			},
			//购买
			liveBuyCard(){
				//+--------------全屏情况下退出全屏-----------------
				if(this.isFullScreen){
					commonJs.exitFullscreen();
				}
				//+---------------未登录提示-----------------------
				if(!localStorage.getItem('user')){
					this.$message.error('请登录后操作');
					return false;
				}

				//+-----------弹出买卡对话框（进入支付流程）---------
				this.buyCardShow = true;
			},
			//阿里web播放器
			aliPlayerInit(){
				setTimeout(() => {
					var _this = this;
					this.aliPlayer = new Aliplayer({
						id: "J_prismPlayer", // 容器id
						source: this.liveDetail.lvpPullUrlFlv,//视频地址
						// source: this.liveDetail.lvpPullUrl,
						// liveShiftSource:this.liveDetail.lvpPullUrl,
						//cover: this.liveDetail.lvrImgLargeUrl,  //播放器封面图
						width: this.playerOptions.width,       // 播放器宽度
						height: this.playerOptions.height,      // 播放器高度
						autoplay:true,      // 是否自动播放
						isLive:this.aliPlayerOptions.isLive,	//是否直播
						rePlay:false,
						playsinline: true,
						preload:true,
						controlBarVisibility:'always',
						useH5Prism:true,
						showBuffer:true,
						components:[
							{
								name: 'PreviewVodComponent',
								type: AliPlayerComponent.PreviewVodComponent,
								/* 第一个参数是试看时长, 单位为分钟 */
								/* 第二个参数可以传一个 Dom 字符串, 他将会替换默认的'试看已结束...'等文字 */
								args: [this.tryLookTimeNow, '#endPreviewTemplate', `<a href="javascript:;" class="vip-join" onclick="liveBuyCard()">立即购买</a> 观看完整视频`]
							},
						],
						"skinLayout": [
							{name: "bigPlayButton", align: "blabs", x: 30, y: 80},
							{name: "H5Loading",align: "cc"},
							{name: "errorDisplay",align: "tlabs",x: 0,y: 0},
							{name: "infoDisplay",align: "tlabs"},
							{
								name: "controlBar",align: "blabs",x: 0,y: 0,
								children: [
									{name:"liveDisplay", align:"tlabs", x:15, y:6},
									{name: "fullScreenButton",align:"tr",x:10,y:15},
									// {name:"subtitle", align:"tr",x:15, y:12},
									// {name:"setting", align:"tr",x:15, y:12},
									{name: "volume",align:"tr",x:5,y:10}
								]
							}
						]
					},(aliPlayer) => {
						// console.log('播放器创建成功');
						// this.aliPlayer.mute();
						this.aliPlayer.play();
					});

					this.aliPlayer.on('ready',() => {
						// console.log('视频可播放');

						//+-------------------未购买------------------
						if(this.liveDetail.auditionFlag && this.liveDetail.isBuy == 0){
							// this.aliPlayer.liveShiftSerivce.setLiveTimeRange(this.liveDetail.seeStartTime,this.liveDetail.seeEndTime);

							//跳转一个指定时刻播放
							// this.aliPlayer.seek(this.liveDetail.configAuditionDuration);
						}
					});

					this.aliPlayer.on('autoplay', (data) => {
						if(data.paramData){
							//可以自动播放隐藏提示
						}else{
							//不可以自动播放，显示提示用户点击播放
							this.$message('当前浏览器自动播放受限制，请点击左下角播放按钮开始播放');
							this.aliPlayer.pause();
						}
					});

					this.aliPlayer.on('playing',(data) => {
						// console.log('正在播放',data);
					});

					this.aliPlayer.on('pause',() => {
						// console.log('播放暂停');
						//回传播放时间
						this.updateTryLookTime();
					});

					this.aliPlayer.on('ended',function  (e) {
						// console.log('播放结束');
						//+----------直播结束，播放地址移除-------------
						this.payLiveCoverShow = true;
						this.liveDetail.lvpPullUrlFlv = null;
						this.liveDetail.lvrIsFree = 1;
						this.liveDetail.lvrStatus = 0;
						this.aliPlayer.dispose();
					});

					this.aliPlayer.on('error',function  (e) {
						// console.log('播放异常',e);
					});

					this.aliPlayer.on('liveStreamStop',function(){
						// console.log('直播流中断');
						//付费直播、未购买、自动结束试看
						if(this.liveDetail.lvrIsFree == 1 && this.liveDetail.isBuy == 0 && this.liveDetail.auditionChangeMode == 'AUTO'){
							//回传播放时间
							this.updateTryLookTime();
						}
					});

					//播放位置发生改变时触发，仅H5播放器
					this.aliPlayer.on('timeupdate',() => {
						let time = parseInt(this.aliPlayer.getCurrentTime()); // 获取播放的时间
						//已经播放时长
						this.alreadyLookTime = time;
						// console.log('+-----播放进度改变',time);
						//+------------付费直播、未购买、需要试看--------------------
						if(this.liveDetail.lvrIsFree == 1 && this.liveDetail.isBuy == 0){
							//自动结束试看
							if(this.liveDetail.auditionChangeMode == 'AUTO'){
								if(this.liveDetail.auditionFlag == false){
									//试看结束，销毁播放器，弹出购买框
									this.aliPlayer.dispose();
									this.liveDetail.lvrIsFree = 1;
									this.liveDetail.lvrStatus = 0;
									//试看结束图层显示
									this.livePreviewEndShow = true;
									this.liveDetail.lvpPullUrlFlv = null;
								}else{
									//展示试看条
									document.querySelector('.preview-vod-component').style.display = 'block';
									//试看倒计时[试看进度条显示并且层级为0,防止出现在弹框层上]
									var lookTime = this.tryLookTimeNow - time;
									document.querySelector('.preview-time').textContent = lookTime + '秒';
									document.querySelector('.preview-component-tip').style.zIndex = '0';
									//试看时间到期
									if(this.liveDetail.seeDuration <= 0 || lookTime <= 0){
										// 时间达到试看时间后把对应的video隐藏，防止安卓浏览器劫持不显示试看组件的提示
										document.querySelector('video').style.display = 'none'
										document.querySelector('.prism-big-play-btn').style.width = '0'

										//试看结束，销毁播放器，弹出购买框
										this.liveDetail.lvrIsFree = 1;
										this.liveDetail.lvrStatus = 1;
										this.liveDetail.seeDuration = 0;
										//试看结束图层显示
										this.livePreviewEndShow = true;
										this.liveDetail.lvpPullUrlFlv = null;
										this.aliPlayer.dispose();
										//更新已试看时间
										_this.updateTryLookTime();
										// this.liveBuyCard();
										return false;
									}
								}
							}
							//手动结束试看
							if(this.liveDetail.auditionChangeMode == 'MANUAL'){
								//实时获取结束配置标识
								if(this.mqttLiveStop){
									//试看结束，销毁播放器，弹出购买框
									this.aliPlayer.dispose();
									this.liveDetail.lvrIsFree = 1;
									this.liveDetail.lvrStatus = 0;
									this.liveDetail.lvpPullUrlFlv = null;
									// this.liveBuyCard();
									return false;
								}
							}
						}
					});

					this.aliPlayer.on('ended',() => {
						// console.log('播放结束');
					});

					this.aliPlayer.on('onM3u8Retry',function(){
					   // console.log('主播暂时离开，请稍后......');
					});

					this.aliPlayer.on('liveStreamStop',() => {
						// console.log('直播失败或已结束');

						//切换直播流
						// this.aliPlayer.loadByUrl();
					});
				},500);
			},
			//更新试看时间
			updateTryLookTime(){
				//+----------------构建请求参数---------------------
				var time = 0;
				if(this.liveDetail.seeDuration > this.alreadyLookTime){
					time = parseInt(this.liveDetail.seeDuration - this.alreadyLookTime);
				}
				let data = {
					lvrId:this.liveDetail.lvrId,
					duration:time,
				};
				//+----------------更新试看时间---------------------
				this.apiServer.live.updateLookTime(this.qs.stringify(data))
				.then(res => {
					if(res.data.code == 200){}
				})
				.catch(res => {
					// console.log('更新试看时间异常');
				});
			},
			/**
			* 响应屏幕变化事件，给isFullscreen赋值，标识是否全屏
			* IE中bug: 调试器打开，且与页面不分离时 -- 无效
			* **/
			onresize(event) {
			    // 利用屏幕分辨率和window对象的内高度来判断兼容IE
			    let winFlag = window.innerHeight === window.screen.height
			    // 利用window全屏标识来判断 -- IE无效
			    let isFull = window.fullScreen || document.webkitIsFullScreen

			    if (isFull === undefined) {
			        this.isFullscreen = winFlag
			    } else {
			        this.isFullscreen = winFlag || isFull;
					this.isFullScreen = !this.isFullScreen
			    }
			},
			//密码房输入密码
			passwordLive(){
				this.$parent.passwordLive();
			},
			//回传当前在线用户信息
			updateLiveOnline(){
				// console.log('心跳测试')
				var userInfo = JSON.parse(localStorage.getItem('user'));
				if(!userInfo) return false;
				//+---------------------构建参数---------------------
				let data = {
					userId:userInfo.ubId,
					nickName:userInfo.udNickname,
					liveId:this.nowRoomId,
					clientType:3,	//0 App 1小程序 2全部 3官网 4 H5
					systemType:6,	//操作系统 1安卓 2苹果
				};
				//+-------------------回传在线信息-------------------
				this.apiServer.live.updateLiveOnline(this.qs.stringify(data))
				.then(res => {})
				.catch(error => {
					// console.log(error);
				});
			},
			//检测直播地址协议
			checkVideoUrl(){
				var videoUrl = this.liveDetail.lvpPullUrlFlv;
				var index = videoUrl.indexOf(":");
				var videoAgreement = videoUrl.substring(0,index+1);

				var locationUrl = window.location.href;
				var locationIndex = locationUrl.indexOf(":");
				var locationAgreement = locationUrl.substring(0,index+1);
				var locationOther = locationUrl.substring(index+2);

				if(videoAgreement !== locationAgreement && (videoAgreement == 'http:' && locationAgreement == 'https')){
					this.$confirm('视频资源的协议应与页面协议一致！当前资源协议与网页的协议不一致，是否将网页跳转到和视频资源的协议一致', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						window.location.href = videoAgreement+locationOther;
						return false;
					}).catch(() => {
						this.$message({
							type: 'info',
							message: '已取消跳转'
						});
					});
				}
			},
			//清除相关定时
			clearTimer(){
				//+-------------------清除心跳定时------------------
				clearInterval(this.updateOnlineTimer);
			},
		}
	}

	window.liveBuyCard = function(){
		window.vm.liveBuyCard();
	}
</script>

<style>
	#livePlay{
		width: 100%;
		height: 100%;
		overflow: hidden;
	}

	.not_living{
		position: relative;
	}

	.freeLive>img{
		width: 100%;
		height: 520px;
	}

	.freeLiveDesc{
		position: absolute;
		color: #FFFFFF;
		top: 158px;
		width: 100%;
		text-align: center;
	}

	.payLiveDesc{
		position: absolute;
		color: #FFFFFF;
		top: 100px;
		text-align: center;
		width: 100%;
	}

	.not_living-title{
		height: 42px;
		font-size: 30px;
		font-family: PingFangSC-Semibold, PingFang SC;
		font-weight: 600;
		color: #FFFFFF;
		line-height: 42px;
		margin-top: 80px;
		margin-bottom: 21px;
	}
	.not_living-desc{
		height: 29px;
		font-size: 21px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #FFFFFF;
		line-height: 29px;
		margin-bottom: 32px;
	}
	.not_living-pay{
		width: 253px;
		height: 60px;
		background: linear-gradient(102deg, #FCE482 0%, #F7C54B 100%);
		border-radius: 4px;
		margin-left: 315px;
		margin-bottom: 157px;
		font-size: 30px;
		color: #000000;
		cursor: pointer;
		line-height: 60px;
		margin: 0 auto;
	}

	.passwordLive-title{
		height: 42px;
		font-size: 30px;
		font-family: PingFangSC-Semibold, PingFang SC;
		font-weight: 600;
		color: #FFFFFF;
		line-height: 42px;
		margin-top: 50px;
		margin-bottom: 21px;
	}


	.vip-join {
	  color: #00c1de;
	}

	.vip_limit_content {
	  display: flex;
	  width: 100%;
	  height: 100%;
	  flex-wrap: wrap;
	  justify-content: center;
	  align-items: center;
	}

	.vip_limit_content .title {
	  font-size: 18px;
	  line-height: 36px;
	  color: #fff;
	  text-align: center;
	  width: 100%;
	}

	.vip_limit_button_box {
	  text-align: center;
	  white-space: nowrap;
	  overflow: hidden;
	  width: 100%;
	}

	.vip_limit_btn {
	  display: inline-block;
	  min-width: 100px;
	  position: relative;
	  background: #f60;
	  padding: 0 35px;
	  margin: 0px 5px 20px 5px;
	  border-radius: 38px;
	  font-size: 18px;
	  line-height: 38px;
	  color: #623A0C;
	  text-align: center;
	  background-image: linear-gradient(-135deg, #FBE8A8 0%, #F8E7AC 15%, #E2C078 100%);
	  cursor: pointer;
	}

	.vip_limit_close {
	  text-align: center;
	}
	.vip_limit_close span {
	  display: inline-block;
	  width: 40px;
	  height: 40px;
	  line-height: 36px;
	  background: rgba(165, 165, 165, 0.54);
	  border-radius: 50%;
	  font-size: 24px;
	  cursor: pointer;
	}

	.luckDialog .el-dialog{
		background:rgba(0,0,0,0.5);
	}
	#luckNotice{
		text-align: center;
	}
	#luckNotice .luck-desc{
		font-size: 24px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: #FFFFFF;
		line-height: 33px;
		text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.5);
	}
	.luckDialog-close{
		text-align: center;
	}
</style>


// WEBPACK FOOTER //
// src/components/common/livePlay.vue